import React from 'react';
import { useCurrentModule } from '../components';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useSwitchFlows } from './useSwitchFlows';
export const UPGRADE_RECOMMENDATION_SPEC = 'secondUpgradeRecommendation';
export const UPGRADE_RECOMMENDATION_MOBILE_SPEC = 'secondUpgradeRecommendationMobile';
export const UPGRADE_RECOMMENDATION_SHADOW_SPEC = 'secondUpgradeRecommendationShadow';
export const useUpgradeRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    isQuickPayLightbox
  } = module.internals.useContext();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isUpgradeFlow,
    isDowngradeFlow
  } = useSwitchFlows();
  const {
    data: offering,
    isLoading: isOfferingLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const subscription = offering == null ? void 0 : offering.currentSubscriptionInfo;
  const hasSubscription = Boolean((subscription == null ? void 0 : subscription.subscriptionId) && (subscription == null ? void 0 : subscription.productFamilyId));
  const isLoading = isSwitchFlow === true && (ready === false || isOfferingLoading);
  const isEligible = !isLoading && (isUpgradeFlow || isDowngradeFlow) && !isQuickPayLightbox && hasSubscription;
  const spec = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME ? UPGRADE_RECOMMENDATION_MOBILE_SPEC : UPGRADE_RECOMMENDATION_SPEC;
  const isVariantB = isEligible && experiments.isEnabled(spec);
  const isShadowEnabled = isEligible && !isVariantB && experiments.isEnabled(UPGRADE_RECOMMENDATION_SHADOW_SPEC);
  const ineligibleReasons = React.useMemo(() => {
    if (isLoading || isEligible) {
      return [];
    }
    const reasons = [];
    if (isSwitchFlow === undefined) {
      reasons.push('switch_flow_unknown');
    } else if (!isSwitchFlow) {
      reasons.push('not_switch_flow');
    }
    if (isQuickPayLightbox) {
      reasons.push('quickpay_lightbox');
    }
    if (!hasSubscription) {
      reasons.push('no_subscription');
    }
    return reasons;
  }, [isLoading, isEligible, isSwitchFlow, isQuickPayLightbox, hasSubscription]);
  return {
    isEligible,
    shouldFetch: isVariantB || isShadowEnabled,
    isShadow: isShadowEnabled,
    variant: isVariantB ? 'B' : 'A',
    entry: isDowngradeFlow ? 'change_plan' : 'upgrade',
    ineligibleReasons,
    isLoading
  };
};
//# sourceMappingURL=useUpgradeRecommendationEnabled.js.map